
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ventures",
      function () {
        return require("private-next-pages/ventures.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ventures"])
      });
    }
  